var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"statusIcon"},[(_vm.status === 'InProgress')?_c('i',{staticClass:"fa fa-spinner"}):(_vm.status === 'Failed')?_c('i',{staticClass:"fa fa-exclamation-circle"}):(_vm.status === 'Ready')?_c('i',{staticClass:"fa fa-check-circle-o"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }